module.exports = "/fast-coin/img/coin/anim/in/coin_in_008.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_008.png
// module id = 2278
// module chunks = 5